import React from 'react'
import Layout from '../../components/dashboard/Layout'

const Home = () => {
    return (
        <Layout>
            <div class="mb-3"><b>Selamat datang di SIBI.</b></div>
            
            <p>SIBI hadir untuk siswa, orang tua, dan guru! Unduh bahan ajar resmi dari pemerintah dengan mudah, kapan saja, dan di mana saja. Belajar jadi lebih cerdas, mengajar jadi lebih efektif.</p>
            
            <div className="my-3">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/opfEbJFIRpM" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
        </Layout>
    )
}

export default Home